import {
  faAsterisk,
  faBracketsCurly,
  faBracketsSquare,
} from "@fortawesome/pro-regular-svg-icons";
import { capitalize } from "lodash-es";

import { Pill } from "src/base-components/Pill";

const LARGE_CELL_VALUE_LENGTH = 1000;

const getIcon = (type: string) => {
  if (type === "array") {
    return faBracketsSquare;
  }

  if (type === "object") {
    return faBracketsCurly;
  }

  return faAsterisk;
};

export const JSONPill: React.FC<{
  value: string;
  type: string;
}> = ({ value, type }) => {
  if (value.length === 0) {
    return <div />;
  }

  if (value.length > LARGE_CELL_VALUE_LENGTH) {
    return (
      <div className="min-w-0 flex-auto">
        <Pill size="sm" variant="gray" maxWidth>
          <Pill.Icon icon={getIcon(type)} />
          <Pill.Text>{capitalize(type)}</Pill.Text>
        </Pill>
      </div>
    );
  }

  return (
    <div className="min-w-0 flex-auto">
      <Pill size="sm" variant="gray" maxWidth>
        <Pill.Text>{value.slice(0, 75)}</Pill.Text>
      </Pill>
    </div>
  );
};
